import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreateCampaign = () => {
  return (
    <Create
      title="Създаване на кампания"
      redirect="list"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm mode="create" />
      </SimpleForm>
    </Create>
  );
};

export default CreateCampaign;
